import React, { Component } from 'react';

import { EditCommandCell } from '../../../common/tableEditCommandCell';
import AddIcon from '@material-ui/icons/Add';
import Fab from '@material-ui/core/Fab';
import Paper from '@material-ui/core/Paper';
import TableCell from '@material-ui/core/TableCell';

import NoteCreateDialog from './noteCreateDialog.component';
import NoteDetailDialog from './noteDetailDialog.component';
// import { BASE_URL } from '../../../middleware/api';

import { getAuthToken } from '../../../utilities/authUtils';
import { BASE_URL as INTAKE_V2_BASE_URL } from '../../../middleware/intakeV2Api';

import {
  Getter,
} from '@devexpress/dx-react-core';

import {
  DataTypeProvider,
  EditingState,
  FilteringState,
  IntegratedFiltering,
  IntegratedPaging,
  IntegratedSorting,
  PagingState,
  SortingState,
} from '@devexpress/dx-react-grid';

import {
  Grid,
  PagingPanel,
  Table,
  TableColumnResizing,
  TableEditColumn,
  TableFilterRow,
  TableHeaderRow,
} from '@devexpress/dx-react-grid-material-ui';

import { dateFormatter } from '../../../utilities/dateFormatter';

const DateTypeProvider = (props) => (
  <DataTypeProvider
    formatterComponent={dateFormatter}
    {...props}
  />
);

class NotesGrid extends Component {
  constructor(props) {
    super(props);

    this.state = {
      columns: [
        {
          name: 'categoryId',
          title: 'Category',
          
        },
        { name: 'addedBy', title: 'Added By' },
        { name: 'addedOn', title: 'Date' },
        { name: 'subject', title: 'Subject' },
        { name: 'description', title: 'Description' },
      ],
      columnWidths: [
        { columnName: 'categoryId', width: 200 },
        { columnName: 'addedBy', width: 275 },
        { columnName: 'addedOn', width: 300 },
        { columnName: 'subject', width: 325 },
        { columnName: 'description', width: 525 },
      ],
      rows: [],
      currentPage: 0,
      pageSize: 5,
      pageSizes: [5, 10, 15],
      dateColumns: ['addedOn'],
      sorting: [{ columnName: 'addedOn', direction: 'desc' }],
      filters: [],
      noteViewDialog: {
        dialogOpen: false,
        selectedRow: null,
      },
      noteCreateDialog: {
        dialogOpen: false,
      },
    };

    this.changeSorting = (sorting) => this.setState({ sorting });

    this.changeCurrentPage = (currentPage) => this.setState({ currentPage });
    this.changePageSize = (pageSize) => this.setState({ pageSize });

    this.changeFilters = (filters) => this.setState({ filters });

    this.handleOpenNoteDetails = this.handleOpenNoteDetails.bind(this);
    this.handleDialogResponse = this.handleDialogResponse.bind(this);
    this.handleNewNote = this.handleNewNote.bind(this);
    this.downloadAttachment = this.downloadAttachment.bind(this);
    this.getDownloadFileName = this.getDownloadFileName.bind(this);

    this.changeColumnWidths = (columnWidths) => {
      this.setState({ columnWidths });
    };

    this.TableRow = ({ row, handleViewSubmittedAuth, ...restProps }) => {
      return (<Table.Row
        {...restProps}
        onClick={() => this.handleOpenNoteDetails(row)}
        style={{
          cursor: 'pointer',
        }}
              />);
    };
  }

  componentWillReceiveProps(nextProps) {
    this.setState({ rows: nextProps.rows || [] });
  }

  componentWillMount() {
    this.setState({ rows: this.props.rows || [] });
  }

  handleOpenNoteDetails(row) {
    this.setState({
      noteViewDialog: {
        dialogOpen: true,
        selectedRow: row,
      },
    });
  }

  handleNewNote() {
    this.setState({
      noteCreateDialog: {
        dialogOpen: true,
      },
    });
  }

  handleDialogResponse(type) {
    if (type === 'NOTE_DETAIL_DIALOG') {
      this.setState({
        ...this.state,
        noteViewDialog: {
          dialogOpen: false,
          selectedRow: null,
        },
      });
    } else if (type === 'NOTE_CREATE_DIALOG') {
      this.setState({
        ...this.state,
        noteCreateDialog: {
          dialogOpen: false,
        },
      });
    }
  }

  // required for editing state
  commitChanges() {

  }

  getCommentId(value) {
    if (!value) {
      return null;
    }

    return (
      value.commentId ??
      value.CommentId ??
      value.CommentID ??
      value.authorizationCommentId ??
      value.AuthorizationCommentId ??
      null
    );
  }

  getAttachmentId(value) {
    if (!value) {
      return null;
    }

    return (
      value.attachmentId ??
      value.AttachmentId ??
      value.attachmentID ??
      value.AttachmentID ??
      value.fileId ??
      value.FileId ??
      value.id ??
      value.Id ??
      null
    );
  }

  getAttachmentIdCandidates(value) {
    if (!value) {
      return [];
    }

    const candidates = [
      value.attachmentId,
      value.AttachmentId,
      value.attachmentID,
      value.AttachmentID,
      value.fileId,
      value.FileId,
      value.id,
      value.Id,
    ];

    const seen = new Set();
    return candidates
      .filter((candidate) => candidate !== null && candidate !== undefined && candidate !== '')
      .filter((candidate) => {
        const key = String(candidate).toLowerCase();
        if (seen.has(key)) {
          return false;
        }
        seen.add(key);
        return true;
      });
  }

  async downloadAttachmentByFileId(fileId, attachmentOrCommentId) {
    const token = getAuthToken();
    const response = await fetch(`${INTAKE_V2_BASE_URL}api/authorizationFile/${encodeURIComponent(fileId)}/download`, {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    if (!response.ok) {
      throw new Error(`Download failed with status ${response.status}`);
    }

    const contentType = response.headers.get('content-type') || '';
    if (contentType.toLowerCase().includes('application/json')) {
      const errorText = await response.text();
      throw new Error(`Download returned JSON payload: ${errorText}`);
    }

    const fileBlob = await response.blob();
    const objectUrl = window.URL.createObjectURL(fileBlob);
    const link = document.createElement('a');
    link.href = objectUrl;
    link.download = this.getDownloadFileName(response, attachmentOrCommentId);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(objectUrl);
  }

  idsMatch(leftId, rightId) {
    if (leftId === null || leftId === undefined || rightId === null || rightId === undefined) {
      return false;
    }

    return String(leftId).toLowerCase() === String(rightId).toLowerCase();
  }

  getAttachmentForRow(row) {
    if (!Array.isArray(this.props.attachments)) {
      return null;
    }

    const rowCommentId = this.getCommentId(row);
    if (!rowCommentId) {
      return null;
    }

    return this.props.attachments.find((attachment) => this.idsMatch(this.getCommentId(attachment), rowCommentId)) || null;
  }

  actionsCell = (props) => {
    const row = props.tableRow.row || {};
    const rowCommentId = this.getCommentId(row);
    const matchedAttachment = this.getAttachmentForRow(row);
    const hasAttachment =
      row.hasAttachment ??
      row.HasAttachment ??
      !!matchedAttachment;

    return (
      hasAttachment > 0 || hasAttachment === true
        ? (
          <TableCell>
            <EditCommandCell
              id="attachment"
              text="attachment"
              icon="paperclip"
              onExecute={() => {
                this.downloadAttachment(matchedAttachment || rowCommentId);
              }}
              tableRow={props.tableRow}
            >{React.Children.toArray(props.children)}
            </EditCommandCell>
          </TableCell>
        ) : <TableCell />
    );
  }

  getDownloadFileName(response, attachment) {
    const contentDisposition = response.headers.get('content-disposition') || '';
    const utf8FileNameMatch = contentDisposition.match(/filename\*=UTF-8''([^;]+)/i);
    if (utf8FileNameMatch && utf8FileNameMatch[1]) {
      return decodeURIComponent(utf8FileNameMatch[1]);
    }

    const fileNameMatch = contentDisposition.match(/filename="?([^";]+)"?/i);
    if (fileNameMatch && fileNameMatch[1]) {
      return fileNameMatch[1];
    }

    return attachment?.fileName || attachment?.FileName || 'attachment';
  }

  async downloadAttachment(attachmentOrCommentId) {
    const attachmentIdCandidates =
      attachmentOrCommentId && typeof attachmentOrCommentId === 'object'
        ? this.getAttachmentIdCandidates(attachmentOrCommentId)
        : [];

    for (const candidateId of attachmentIdCandidates) {
      try {
        await this.downloadAttachmentByFileId(candidateId, attachmentOrCommentId);
        return;
      } catch (error) {
        console.error(`Attachment download failed for candidate id ${candidateId}:`, error);
      }
    }
  }

  render() {
    const { rows, columns, pageSize, pageSizes, currentPage, dateColumns, filters, sorting, noteViewDialog, noteCreateDialog, columnWidths } = this.state;
      
    return (
      <div>
        <div style={{ float: 'right', marginTop: '0.25rem', marginRight: '0.25rem' }}>
          <Fab color="secondary" aria-label="add" onClick={this.handleNewNote}>
            <AddIcon />
          </Fab>
        </div>

        <NoteDetailDialog
          fullScreen={false}
          open={noteViewDialog.dialogOpen}
          noteData={noteViewDialog.selectedRow}
          noteAttachments={this.props.attachments && this.props.attachments.length > 0 ? this.props.attachments : []}
          type={'NOTE_DETAIL_DIALOG'}
          handleResponse={this.handleDialogResponse}
          title={'Authorization Note Detail'}
          downloadAttachment= {this.downloadAttachment}
          enums={this.props.enums}
        />

        <NoteCreateDialog
          fullScreen={false}
          open={noteCreateDialog.dialogOpen}
          authorizationId={this.props.authId}
          type={'NOTE_CREATE_DIALOG'}
          handleResponse={this.handleDialogResponse}
          title={'Add Note to Authorization File'}
          enums={this.props.enums}
        />

        <Paper style={{ padding: '1rem' }}>
          <div style={{ padding: '1rem', fontSize: '1.5rem', width: '50%' }}>Notes</div>
          <Grid
            rows={rows ?? []}
            columns={columns}
          >
            <DateTypeProvider
              for={dateColumns}
            />
            <SortingState
              sorting={sorting}
              onSortingChange={this.changeSorting}
            />
            <PagingState
              currentPage={currentPage}
              onCurrentPageChange={this.changeCurrentPage}
              pageSize={pageSize}
              onPageSizeChange={this.changePageSize}
            />
            <IntegratedSorting />
            <FilteringState
              filters={filters}
              onFiltersChange={this.changeFilters}
            />
            <EditingState
              onEditingRowIdsChange={this.changeEditingRowIds}
              onCommitChanges={this.commitChanges}
            />
            <IntegratedFiltering />
            <IntegratedPaging />
            <Table rowComponent={this.TableRow} />
            <TableColumnResizing
              columnWidths={columnWidths}
              onColumnWidthsChange={this.changeColumnWidths}
            />
            <TableHeaderRow showSortingControls />
            <TableEditColumn
              style={{ marginRight: '2rem' }}
              cellComponent={this.actionsCell}
            />
            <TableFilterRow />
            <Getter
              name="tableColumns"
              computed={({ tableColumns }) => {
                const safeTableColumns = tableColumns || [];
                return [
                  ...safeTableColumns.filter((c) => c.type !== TableEditColumn.COLUMN_TYPE),
                  { key: 'editCommand', type: TableEditColumn.COLUMN_TYPE, width: 150 },
                ];
              }}
            />
            <PagingPanel
              pageSizes={pageSizes}
            />
          </Grid>
        </Paper>
      </div>
    );
  }
}

export default NotesGrid;